import React from "react";

function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-gray-700">
      <h1 className="text-4xl font-bold text-center mb-6">About Us</h1>
      <p className="mb-4">
        At <strong>Kriptees</strong>, we believe what you wear should reflect who you are. That’s why we
        create high-quality custom t-shirts, graphic tees, and printed hoodies that help you
        express your style, mood, and individuality effortlessly.
      </p>
      <p className="mb-4">
        Based in India, Kriptees is your go-to online destination to buy printed t-shirts, shop
        graphic t-shirts online, and order custom hoodies for men and women. Whether
        you're after bold prints, original artwork, or a design that’s completely your own,
        we’ve got just the thing.
      </p>
      <p className="mb-4">
        Our products are made with premium materials, soft fabrics, and long-lasting prints
        to ensure comfort with every wear. From trendsetters to creatives, from casual
        streetwear lovers to those looking for personalized fashion — <strong>Kriptees</strong> is for everyone
        who wants to wear something real.
      </p>
      <p className="mb-4">
        With seamless customization, secure checkout, and fast nationwide delivery,
        Kriptees brings unique fashion to your doorstep — without compromise.
      </p>
      <p className="text-xl font-semibold text-center mt-8">
        Shop now. Wear your story.
      </p>
    </div>
  );
}

export default About;
